import snackbar from './snackbar.vue'
import Vue from 'vue'
const SnackbarConstructor = Vue.extend(snackbar)
let instance
let queue = []

const Snackbar = function (options = {}) {
  instance = new SnackbarConstructor({
    data: options
  }).$mount()
  clear()
  queue.push(instance)
  document.body.appendChild(instance.$el)
}

function clear () {
  if (!queue.length) return
  for (let i = 0; i < queue.length; i++) {
    const instance = queue[i]
    removeNode(instance.$el)
  }
  queue = []
}

function removeNode (el) {
  const parent = el.parentNode
  if (parent) {
    parent.removeChild(el)
  }
}

export default Snackbar



// WEBPACK FOOTER //
// ./src/components/snackbar/index.js